/**
 * LoginPage — phone-number entry, mirrors Flutter `splash/login_page.dart`.
 * On success, the OTP page receives the phone via router state.
 */
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuthStore } from '@/stores/authStore';
import { Button } from '@/components/common/Button';
import { TextField } from '@/components/common/TextField';

export default function LoginPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { sendCode, loading } = useAuthStore();
  const [phone, setPhone] = useState('+963');
  const [error, setError] = useState<string | null>(null);

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError(null);
    const cleaned = phone.replace(/\s+/g, '');
    if (!/^\+?\d{8,15}$/.test(cleaned)) {
      setError(t('phone_invalid', 'رقم الهاتف غير صحيح'));
      return;
    }
    try {
      await sendCode(cleaned);
      navigate('/otp', { state: { phone: cleaned } });
    } catch (err: any) {
      setError(err?.message || t('login_failed', 'فشل تسجيل الدخول'));
    }
  }

  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-4">
      <div className="w-full max-w-md bg-surface rounded-2xl shadow-md p-8">
        <h1 className="text-2xl font-bold text-primary mb-2 text-center">
          {t('app_name', 'كارواتس كارقو')}
        </h1>
        <p className="text-text-secondary text-center mb-8">
          {t('login_subtitle', 'سجّل الدخول برقم هاتفك')}
        </p>
        <form onSubmit={handleSubmit} className="space-y-4">
          <TextField
            label={t('phone_number', 'رقم الهاتف')}
            type="tel"
            inputMode="tel"
            dir="ltr"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            placeholder="+963 9XX XXX XXX"
            error={error ?? undefined}
            autoFocus
          />
          <Button type="submit" loading={loading} fullWidth>
            {t('send_code', 'إرسال الكود')}
          </Button>
        </form>
      </div>
    </div>
  );
}
